import { FamilyStatus } from "protogen/advisors_service_pb";

export type MemberFamilyPlanFlags = {
  familyStatus: FamilyStatus | undefined;
  isDigitalSubscription: boolean;
  isUnpaidSignup: boolean;
};

export function planFlagsFromStatus(
  familyStatus: FamilyStatus | undefined,
): MemberFamilyPlanFlags {
  return {
    familyStatus,
    isDigitalSubscription: familyStatus === FamilyStatus.DIGITAL_SUBSCRIPTION,
    isUnpaidSignup: familyStatus === FamilyStatus.UNPAID_SIGNUP,
  };
}

export function isDigitalDeactivatedStatus(
  familyStatus: FamilyStatus | undefined,
): boolean {
  return (
    familyStatus === FamilyStatus.DIGITAL_DEACTIVATED ||
    familyStatus === FamilyStatus.DIGITAL_DEACTIVATED_TRIAL
  );
}

export function memberSelfServeReactivationPath(
  familyStatus: FamilyStatus | undefined,
): "/digital-upgrade" | "/reactivate" {
  return isDigitalDeactivatedStatus(familyStatus)
    ? "/digital-upgrade"
    : "/reactivate";
}
